<template>
  <div class="queryCashierdiary" v-loading="loading">
    <div class="flex_wrapper">
      <div class="queryCashierdiary-title">日记账</div>
      <!-- 筛选条件 && 操作按钮 -->
      <div class="queryCashierdiary-form">
          <!-- 账户 -->
          <el-select
            placeholder="请选择"
            size="small"
            @change="accountChange"
            v-model="formData.fkJournalAccountId"
            :clearable="false"
            filterable
          >
            <el-option v-for="(item,index) in allAccountList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <!-- 日期范围 -->
          <el-date-picker
            v-model="dateList"
            type="monthrange"
            range-separator="至"
            size='small'
            class="queryCashierdiary-form-date"
            value-format="yyyyMM" format="yyyy年MM期"
            start-placeholder="开始月份"
            @change='getDataChange'
            end-placeholder="结束月份">
          </el-date-picker>
          <!-- 中间操作区域 -->
          <div class="queryCashierdiary-form-textBtn">
            <template v-for="i in centerBtnList">
              <el-button type="text" :key="i.id" @click="handleCenterClick(i)">
                {{i.name}}
                <!-- <public-tips :content="moveTips" v-if="i.permission === 'ac:diary:move'"></public-tips> -->
              </el-button>
            </template>
            <el-button type="text" @click="getTableData">
              刷新
            </el-button>
          </div>
          <!-- 右边操作区域 -->
          <div class="queryCashierdiary-form-right">
              <accBtn text="新增日记账" @click="addCashierdiary"></accBtn>
              <template v-for="item in RightBtnList">
                <el-button size="small"  @click='handleClickOperation(item)' :key="item.id">{{item.name}}</el-button>
              </template>
          </div>
      </div>
    </div>
    <!-- 表格内容 -->
    <div class="queryCashierdiary-table">
      <!-- 表格tab -->
      <div class="queryCashierdiary-table-tab">
          <table-tab @tabClick="tabClick"></table-tab>
      </div>

      <!-- 表格主体 -->
      <div class="queryCashierdiary-table-content" >
         <div v-show="nowTabVal === 999">
           <table-list
             :table="table"
             ref="tableListRef999"
             @idList="idList"
             @delRowData="delRowData"
             @saveMark="saveMark"
             @editRow="editRow"
           >
           </table-list>
         </div>
         <div v-show="nowTabVal === 1">
           <table-list
             :table="table1"
             @idList="idList"
             ref="tableListRef1"
             @delRowData="delRowData"
             @saveMark="saveMark"
             @editRow="editRow"
           >
           </table-list>
         </div>
         <div v-show="nowTabVal === 2">
           <table-list
             :table="table2"
             @idList="idList"
             ref="tableListRef2"
             @delRowData="delRowData"
             @saveMark="saveMark"
             @editRow="editRow"
           >
           </table-list>
         </div>
         <div v-show="nowTabVal === 0">
           <table-list
             :table="table0"
             @idList="idList"
             ref="tableListRef0"
             @delRowData="delRowData"
             @saveMark="saveMark"
             @editRow="editRow"
           >
           </table-list>
         </div>
      </div>
    </div>


    <!-- 设置字段归属弹框 -->
    <choice-type ref="choiceTypeRef" @saveSuccess="saveSuccess"></choice-type>
    <!-- 回收站 -->
    <recycle-bin
      :recycleBinVisible.sync="recycleBinVisible"
      :dateList='[formData.startYearPeriods,formData.endYearPeriods]'
      :del_useList='del_useList'
    ></recycle-bin>
    <!-- 打印 -->
    <c-print ref="cprintRef" @print="handlePrint"></c-print>
    <!-- 导入 -->
    <c-import ref="cimportRef" @import="handleImport"></c-import>
    <!-- 导出 -->
    <c-export ref="cexportRef" @export="handleExport"></c-export>
    <!-- 修改日记账弹框 -->
    <edit-table ref="editTableRef" @successSave="getTableData"></edit-table>
  </div>
</template>
<script>
  import publicTips from "@/components/publicTips/toolTip.vue"
  import tableTab from "./components/c-query-table/c-table-tab.vue"
  import choiceType from "./components/c-query-table/choiceType.vue"
   import {currencys} from '@/assets/utils/currencyFormat'
   import recycleBin from "@/components/dialog/recycleBin"  // 回收站
   import cPrint from "./components/c-query-table/c-print.vue"
   import cImport from "./components/c-query-table/c-import.vue"
   import cExport from "./components/c-query-table/c-export.vue"
   import editTable from "./components/c-query-table/editTable.vue"
   import tableList from "./components/c-query-table/newTableList.vue"
  export default {
    components:{
       publicTips,
       tableTab,editTable,
       choiceType,recycleBin,cPrint,cImport,cExport,
       tableList
    },
    data() {
      return {
        recycleBinVisible:false,
        del_useList:[],
        formData:{
            date:'',
            startYearPeriods: "",
            endYearPeriods: "",
            fkJournalAccountId:'',
           // orderBy:'date ASC,',    // date DESC,  // 降序 date ASC,// 升序
        },
        baseTable:{
          loading:false,
          footerMethod:this.footerMethod,  //  合计显示规则
          customColumns:[],  // 自定义显示列
          config:[],  // 表头
          data:[],
          tableHeight:"",
          tablePage:{
            totalResult:0
          }
        },
        table:{  // 全部表格
        },
        table1:{  // 收入表格
        },
        table2:{  // 支出表格
        },
        table0:{  // 内部转账表格
        },
        moveTips:"可以批量将日记账移动到另外的账户：【账户】 转到 【账户】",
        dateList:[new Date(),new Date()],
        accountList:[],
        centerBtnList:[], //文字按钮集合  移动  删除 回收站
        RightBtnList:[], //右边按钮集合  导入  导出 打印
        loading:false,
        headerConfig:[],  // 表头数据
        tableData:[],
        allData:[],  // 所有数据
        tableKey:0,
        allAccountList:[], //所有账户
        nowTabVal:999,  // 默认选中全部  表格类型
        ids:[],
        PDFcustomList:[],
        params:new FormData(),
        firstGoIn:true,  // 是不是第一次进入页面
        checkBoxConfig:{
          title: "#",
          slots:{ default: "checkbox"},
          value: 'checkbox',
          valueType:0,
          type: 'checkbox',
          id: 998,
          field:"checkbox",
          width:55,
          fillRule:0,  // 归属Number  0 收支都填 1收入  2支出
          isChioce:0,
          decimalNum:0,
          isTotal:0,
          fixed: "left",
          optionList:[],
          imgList:[],
          filterMethod: null,
          filters:null,
        },
        operationConfig:{  // 操作配置
          title: "操作",
          slots:{ default: "operation"},
          value: 'operation',
          valueType:0,
          type: 'operation',
          id: 999,
          field:"operation",
          width:115,
          fillRule:0,  // 归属Number  0 收支都填 1收入  2支出
          isChioce:0,
          decimalNum:0,
          isTotal:0,
          fixed: "right",
          optionList:[],
          imgList:[],
          filterMethod: null,
          filters:null,
        }
      }
    },
    created() {
       this.intData();
      // 初始化参数
      this.formData.startYearPeriods = this.$formart(new Date(),"yyyyMM");
      this.formData.endYearPeriods = this.$formart(new Date(),"yyyyMM");

      // 初始化表格
      this.table = this.$lodash.cloneDeep(this.baseTable);
      this.table1 = this.$lodash.cloneDeep(this.baseTable);
      this.table2 = this.$lodash.cloneDeep(this.baseTable);
      this.table0 = this.$lodash.cloneDeep(this.baseTable);
    },
    mounted() {
      this.userChoice();
    },
    activated() {
      if(!this.firstGoIn) {
        this.getTableHeader();
      }
      this.firstGoIn = false;
    },
    methods:{
      saveSuccess() {
        this.intData();
      },
      intData() {
        this.getButtonAuthorize();
        this.getTableHeader();
        this.getAllAccount();
        this.getPDFcustom();
      },
      // 编辑表格行数据
      editRow(row) {
        this.$refs.editTableRef.dataRow = this.$lodash.cloneDeep(row);
        this.$refs.editTableRef.dialogVisible = true;
      },
      // 导出
      handleExport(data) {
        if(data.exportType==="2") {
          this.handlePrint(data,"export");
          return
        }
        if(data.exportScope==="1") {
          if(!this.ids.length) {
            return this.$message.warning('检测到当前无勾选数据！')
          }else if(this.ids.length > 200) {
            return this.$message.warning('手动选中条数必须小于200条！当前选中条数：' + this.ids.length)
          }
        }
        let listData = data.checkList.filter(i=>{
          return (i!=="1") && (i!=="2") && (i!=="3") && (i!=="4")
        })
        let params = {
            cid: sessionStorage.cid,
            token: sessionStorage.token,
            printingMode:data.exportScope,     // 打印或者导出范围 1=当前勾选 2=当前期间
            fkJournalAccountId: this.formData.fkJournalAccountId,
            startYearPeriods: this.formData.startYearPeriods,
            endYearPeriods: this.formData.endYearPeriods,
            ids:data.exportScope==1?this.ids.join(','):"",
            customClumns:listData.join(','),     // 所选自定义列 以,号隔开
          }
          const router =this.$router.resolve({
            path: '/export/exportJournalPeriod',
            query: params
          })
          window.location.href = this.$rootUrl + router.href;
      },
      // 导入
      handleImport(list) {
        this.params = new FormData();
        // 导入验证
        if(list.length>1) {
          return this.$message.warning('只能从列表选择一个上传哟!')
        }
        if(!list.length) {
          return this.$message.warning('请选择上传文件!')
        }
        let fileOne = list[0];
        let testmsg=fileOne.name.substring(fileOne.name.lastIndexOf('.')+1)
        const extension = testmsg === 'xls'
        const extension2 = testmsg === 'xlsx'
        const isLt5M = fileOne.size / 1024 / 1024 < 5
        if(!extension && !extension2) {
          return this.$message({
            message: '上传文件只能是 xls、xlsx格式!',
            type: 'warning'
          });
        }
        if(!isLt5M) {
          return this.$message({
            message: '上传文件大小不能超过 5MB!',
            type: 'warning'
          });
        }
        // end
        this.params.append('fkJournalAccountId',this.formData.fkJournalAccountId);
        //this.params.append('date',this.formData.date);
        this.params.append('multipartFile',fileOne.raw);
        this.params.append('cid',sessionStorage.getItem('cid'));
        this.params.append('token',sessionStorage.getItem('token'));
        try {
         const instance = this.$http.create({
           withCredentials: true
         })
         this.$refs.cimportRef.isImportFilesLoading = true;
         instance.post(this.$rootUrl + 'journal/importFileJournalPeriod', this.params).then(res=>{
           this.$refs.cimportRef.isImportFilesLoading = false;
           if(res && res.data.code == 1) {
             this.$message.success(res.data.msg)
             this.$refs.cimportRef.importSuccess();
             this.getTableData();
           }else {
              this.$message.error(res.data.msg)
           }
         })
        }catch(e) {
          this.$refs.cimportRef.isImportFilesLoading = false;
        }
      },
      // 打印
      handlePrint(data,type) {
        if(data.exportScope==="1") {
          if(!this.ids.length) {
            return this.$message.warning('检测到当前无勾选数据！')
          }else if(this.ids.length > 200) {
            return this.$message.warning('手动选中条数必须小于200条！当前选中条数：' + this.ids.length)
          }
        }
        let listData = data.checkList.filter(i=>{
          return (i!=="1") && (i!=="2") && (i!=="3") && (i!=="4")
        })
        const params = {
          cid: sessionStorage.cid,
          token: sessionStorage.token,
          printingMode:data.exportScope,     // 打印或者导出范围 1=当前勾选 2=当前期间
          ids:this.ids.join(','),
          customClumns:listData.join(','),     // 所选自定义列 以,号隔开
          fkJournalAccountId: this.formData.fkJournalAccountId,
          startYearPeriods: this.formData.startYearPeriods,
          endYearPeriods: this.formData.endYearPeriods,
          type:type?type:"",     // 打印日记账and导出日记账pdf格式 type=export为导出
        }
        const router = this.$router.resolve({
          path: '/createPDF/printDiary',
          query: params
        })
        window.open(this.$rootUrl + router.href, '_blank');
      },
      // 按钮操作
      handleClickOperation(row) {
        if(row.permission === "ac:diary:print") {  // 打印
          let printDom =  this.$refs.cprintRef;
          printDom.printFormData.checkList = [];
          printDom.printDialogShow = true;
          printDom.PDFcustomList = this.$lodash.cloneDeep(this.PDFcustomList);
          if(this.PDFcustomList.length) {
            this.PDFcustomList.forEach(i=>{
              printDom.printFormData.checkList.push(i.id);
            })
          }
        }else if(row.permission === "ac:diary:export") { // 导出
          let exportDom =  this.$refs.cexportRef;
          exportDom.printFormData.checkList = [];
          exportDom.exportDialogShow = true;
          exportDom.PDFcustomList = this.$lodash.cloneDeep(this.PDFcustomList);
          if(this.PDFcustomList.length) {
            this.PDFcustomList.forEach(i=>{
              exportDom.printFormData.checkList.push(i.id);
            })
          }
        }else if(row.permission === "ac:diary:import") {  // 导入
          if(!this.formData.fkJournalAccountId) {
            return this.$message.warning('日记账账户不能为全部，请重新选择')
          }
          let importDom =  this.$refs.cimportRef;
          importDom.importFiles = true;
        }
      },
      // 获取自定义选择列
      getPDFcustom() {
         this.$http.post('custom/getPDFcustom',{}).then(res=>{
            if(res && res.data.code == 1) {
              this.PDFcustomList = res.data.data;
            }
         })
      },
      // 中间按钮点击  回收站&&批量删除
      handleCenterClick(item) {
        if(item.permission === "ac:diary:recovery") {  // 回收站
          this.recycleBinVisible = true;
        }else if(item.permission === "ac:diary:deleted") {
          if(!this.ids.length) return this.$message.warning("系统未检测到所选数据！")
          this.delRowData({ id: this.ids.toString()})
        }
      },
      idList(data) {
        this.ids = data;
      },
      // 删除表格数据
      delRowData(row) {
        this.$prompt('此操作将删除所选数据,您可在下面输入框输入删除原因(可选)', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPlaceholder:"可输入删除原因",
          }).then((val) => {
          	this.$http.post('journal/deleteJournalPeriod' , {ids:row.id,because:val.value}).then(res=>{
              if(res&&res.data.code == 1) {
                this.getTableData();
                this.$message({
                        type: 'success',
                        message: res.data.msg
                      });
              }
            })
          }).catch(() => {

        });
      },
      // 保存标记
      saveMark(row) {
        // console.log(row)
        let params = {
          id: row.id,
          signId: row.signId_c,
          signReason: row.signReason_c
        }
        this.$http.post('journal/setJournalUpSign',params).then(res=>{
          if(res && res.data.code == '1'){
            this.getTableData();
            this.$message.success("标记成功！")
          }
        }).catch(e=>{

        });
      },
      // 查询所有账户
      getAllAccount(){
        this.$http.post('journal/findAccount',{type:-1}).then(res=>{
          if(res && res.data.code == '1'){
            let datas = res.data.data;
            datas.unshift({
              name:"全部",
              id:""
            })
            this.allAccountList = this.$lodash.cloneDeep(datas);
            this.del_useList = datas;
            if(datas.length) {  // 如果账户没有值 则不请求数据
             // this.getTableData();
            }
          }
        }).catch(e=>{

        });
      },
      // tab点击@type Number 999全部 1收入 2支出 0内部转账
      tabClick(type) {
        this.nowTabVal = type;
        this.recalculateTable(type);
        this.tableScrollBottom();
        this.getTableHeight();
      },
      // 重新计算当前table
      recalculateTable(type) {
        let refName = "tableListRef" + type;
        this.$nextTick(()=>{
          this.$refs[refName].$children[0].recalculate();  // 重新计算表格样式
        })
      },
      // 处理获取所有表格的数据
      getAllData() {
        if(!this.allData.length || !this.headerConfig.length) return;
        let list1 = [],list2 = [],list0 = [];
        this.allData.forEach((i,index)=>{
          if(i.transfer===1 || index===0) {
            list1.push(i);
          }
          if(i.transfer===2 || index===0) {
            list2.push(i);
          }
          if(i.transfer===0 || index===0) {
            list0.push(i);
          }
        })

        this.handleTableHeader(999,this.allData);  // 处理全部表头
        this.handleTableHeader(1,list1);  // 处理收入表头
        this.handleTableHeader(2,list2);  // 处理支出表头
        this.handleTableHeader(0,list0);  // 处理内部转账表头
      },
      // 赋值表格高度
      getTableHeight() {
        this.$nextTick(()=>{
          let nowTabVal = this.nowTabVal;
          let tableContentDom = document.getElementsByClassName("queryCashierdiary-table-content")[0];
          if(tableContentDom) {
            let tabHeight = tableContentDom.clientHeight + 30;
            let refDom = "tableListRef" + nowTabVal;
            this.$refs[refDom].gridOptions.height = tabHeight;
          }else {
            console.log("未检测到table内容")
          }
        })
      },
      // 表格滚动到最底部函数
      tableScrollBottom() {
        this.$nextTick(()=>{
          // 滚动到表格底部
          setTimeout(()=>{
            let baseDom = document.getElementsByClassName("queryCashierdiary")[0];
            let s = baseDom.getElementsByClassName("vxe-table--body-wrapper");
            if(s && s.length){
              for(var i = 1;i<s.length;i++) {
                s[i].scrollTop = s[i].scrollHeight;
              }
            }
          },500)
        })
      },
      // 处理表头  @fillRule 0 收支都填 1收入填写  2支出填写
      handleTableHeader(type,tableList) {
        let headList = [];
        if(type===999) {
          headList = this.headerConfig;
        }else if(type===0) {
          this.headerConfig.forEach(i=>{
            if(i.id==1 || i.id==2 || i.id==3 || i.id==4 || i.id==999 || i.id==998 || i.title=="账户") {
              headList.push(i)
            }
          })
        }else {
          this.headerConfig.forEach(i=>{
            i.fillRule = i.fillRule?i.fillRule:0;
            if(type===i.fillRule || i.fillRule===0) {
              headList.push(i);
            }
          })
        }

        if(type === 999) {
          this.table.config = this.$lodash.cloneDeep(headList);
          this.table.id = 999;
          this.handleTableData(tableList,999); // 获取所有的数据
        }else{
          let text = "table" + type;
          this[text].config = this.$lodash.cloneDeep(headList);
          this[text].id = type;
          this.handleTableData(tableList,type); // 获取内部转账数据
        }
      },
      // 查询用户所有未禁用自定义字段
      getTableHeader() {
        this.loading = true;
        this.$http.post('journal/findJournalPeriodTitle',{}).then(res=>{
          this.loading = false;
          if(res && res.data.code == 1) {
            let data = res.data.data;
            this.handleHeader(data);
          }
        })
      },
      // 表格数据处理函数 @list 待处理表格数组
      handleTableData(lists,type) {
        let list = this.$lodash.cloneDeep(lists);
        this.table.tablePage.totalResult = list.length?list.length-1:list.length;
        list.forEach((item,index)=>{
          item.signId_c = item.signId;
          item.signReason_c = item.signReason;
          item.isPopoverShow = item.isPopoverShow;
          if(index === list.length-1) {
            item.backgroundColor= "#eff9f6";
          }else {
            item.backgroundColor= "";
          }
         // 自定义余额
         if(index<list.length-1) {
            list[index+1].remainingSum = (Number(list[index].remainingSum)+Number(list[index+1].debitMoney)-Number(list[index+1].creditorMoney)).toFixed(2);
         }
          item.debitMoney = item.debitMoney?item.debitMoney:"";
          item.creditorMoney = item.creditorMoney?item.creditorMoney:"";
          item.remainingSum = item.remainingSum?item.remainingSum:"";
        });
        if(list.length > 0){
          this.nums = list[list.length-1].remainingSum;
        }else{
          this.nums = '';
        };
        this.randerTableEule(type,list,1500);
      },
      /**
       * 渲染表格规则  当前停留的tab表格优先渲染
       */
      randerTableEule(type,list,time) {
        let refDom = "tableListRef" + type,
        nowTabValue = this.nowTabVal,
        lists = this.$lodash.cloneDeep(list);
        if(nowTabValue === type) {  // 优先渲染
        console.log("当前优先渲染：" + type)
          if(type === 999) {
            this.table.data = this.$lodash.cloneDeep(list);
            this.$refs[refDom].getAllData(this.table);
          }else{
            let text = "table" + type;
            this[text].data = this.$lodash.cloneDeep(list);
            this.$refs[refDom].getAllData(this[text]);
          }
          this.getTableHeight();  // 赋值表格高度
          this.tableScrollBottom();  // 滚动到最底部
        }else { // 延迟渲染
          if(type === 999) {
            setTimeout(()=>{
              this.table.data = this.$lodash.cloneDeep(list);
              this.$refs[refDom].getAllData(this.table);
              this.getTableHeight();  // 赋值表格高度
              this.tableScrollBottom();  // 滚动到最底部
            },time)
          }else{
            setTimeout(()=>{
              let text = "table" + type;
              this[text].data = this.$lodash.cloneDeep(list);
              this.$refs[refDom].getAllData(this[text]);
              this.getTableHeight();  // 赋值表格高度
              this.tableScrollBottom();  // 滚动到最底部
            },time)
          }
        }

      },
      // 查询表格返回数据
      getTableData() {
        const _=this,
        nowValue = this.nowTabVal,
        refDom = "tableListRef" + nowValue;
        this.allData = [];
        this.$refs[refDom].gridOptions.loading = true;
         _.$http.post('journal/findJournalPeriodAll',_.formData).then(res=>{
            this.$refs[refDom].gridOptions.loading = false;
            if(res && res.data.code == '1'){
              this.allData = res.data.data.data;
              this.getAllData();
            }
         }).catch(e=>{
         });
      },
      /*
      * 处理后端返回表头主函数  自定义数据加工厂
      **/
      handleHeader(arr) {
        if(arr&&arr.length) {
          this.headerConfig = [];  // 初始化表头数据
          arr.forEach(i=>{
            let baseObj = {
              title:i.columnName,
              slots:{ default: i.value},
              value: i.value,
              valueType:i.valueType,
              type: 'text',
              id: i.id,
              field:i.value,
              decimalNum_s: i.decimalNum_s,
              minWidth:168,
              fillRule:i.fillRule,  // 归属Number  0 收支都填 1收入  2支出
              isChioce:i.isChoice,
              decimalNum:i.decimalNum,
              isTotal:i.isTotal,
              fixed: "",
              optionList:i.optionList,
              imgList:i.imgList,
              filterMethod: null,
              filters:null,
            }
            switch(i.customType) {
              case "1":  // 文本框
                baseObj = Object.assign({},baseObj,{
                  filterMethod: this.filtersTextMethod,
                  filters:[{data:""}],
                  fixed:i.columnName=="账户"?"right":"",
                  minWidth:i.columnName=="账户"?125:250,
                  slots:{
                    default: i.value,
                    filter: 'text_filter',
                  },
                  toolTip:false,
                  render: {name: "input" , autoselect:true}
                })
                break;
              case "2": // 日期
              baseObj = Object.assign({},baseObj,{
                sortable: true,
                type: 'date',
                minWidth:125,
                slots:{
                  default: i.value,
                  filter: 'date_filter',
                },
                fixed:i.id==1?"left":"",
                filterMethod: this.filtersDateMethod,
                filters:[{data: ''},{data: ''}],
              })
                break;
              case "3": // 数值
                baseObj = Object.assign({},baseObj,{
                  sortable: i.id!=="5"?true:false,
                  type: 'number',
                  minWidth:125,
                  slots:{
                    default: i.value,
                    filter: 'number_filter',
                  },
                  filterMethod: this.filtersNumberMethod,
                  filters:[{data: ''},{data: ''}],
                  render: {name: "input" , autoselect:true}
                })
                break;
              case "4": // 单选&&多选
                baseObj = Object.assign({},baseObj,{
                  type: 'select',
                  minWidth:i.isChoice==1?250:125,
                  filterMethod: i.isChoice==1?this.filtersSelect_dMethod:this.filtersSelect,
                  slots:{
                    default: i.value,
                    filter: 'select_filter',
                  },
                  filters:[{data:""}],
                  render: {name: "input" , autoselect:true}
                })
                break;
              case "5": // 图片
                baseObj = Object.assign({},baseObj,{
                  type: 'img',
                })
                break;
              case "6": // 按钮 单选&&多选
                baseObj = Object.assign({},baseObj,{
                  type: 'btn',
                  minWidth:i.isChoice==1?250:125,
                  filterMethod: i.isChoice==1?this.filtersSelect_dMethod:this.filtersSelect,
                  slots:{
                    default: i.value,
                    filter: 'select_filter',
                  },
                  filters:[{data:""}],
                  render: {name: "input" , autoselect:true}
                })
                break;
            }

            this.headerConfig.push(baseObj);
          })
          // 添加操作 operation
          this.headerConfig.push(this.operationConfig);
          this.headerConfig.unshift(this.checkBoxConfig)
          this.table.config = this.$lodash.cloneDeep(this.headerConfig);
          this.getTableData();
        }else {
          throw new Error("无法识别或未获取到日记账表头信息！")
        }
      },
      // 单选搜索
      filtersSelect({option, row,column}) {
      	if(row.isBeginning===1){return true};
      		return column.filters[0].data.find(i=>{return i===row[column.property].id})
        },
      // 多选搜索
      filtersSelect_dMethod({option, row,column}) {
        if(row.isBeginning===1){return true};
        let backMark = false;
        if(option.data) {
          let dataS = option.data;
          if(row[column.property].id!==null) {
            let rowID = row[column.property].id.toString();
            for(let k=0;k<dataS.length;k++){
              let regTest = dataS[k];
              if(rowID.indexOf(regTest) != -1){
               backMark = true;
              }
            }
          }
         }
         return backMark
      },
      // 数值搜索
      filtersNumberMethod ({option, row,column}) {
      		if(row.isBeginning===1){return true};
      		// if(isNaN(column.filters[0].data)||isNaN(column.filters[1].data)) {
      		// 	return this.$message.warning('检索条件只能是数值！')
      		// }
        	if(typeof(row[column.property])==="object") {
        		if(!column.filters[0].data) {
        			return row[column.property].value <=Number(column.filters[1].data);
        		}
        		if(!column.filters[1].data) {
        			return row[column.property].value >=Number(column.filters[0].data);
        		}
        		 return  Number(column.filters[0].data)<= row[column.property].value &&  row[column.property].value <=Number(column.filters[1].data)

        	}else {
        		if(!column.filters[0].data) {
        			return row[column.property] <=Number(column.filters[1].data);
        		}
        		if(!column.filters[1].data) {
        			return row[column.property] >=Number(column.filters[0].data);
        		}
        		 return  Number(column.filters[0].data)<= row[column.property] &&  row[column.property] <=Number(column.filters[1].data)
        	}

      },
      // 日期搜索
      filtersDateMethod({option, row,column}){
      	if(row.isBeginning===1){return true};
      	if(column.filters[0].data&&!column.filters[1].data) {
      		column.filters[1].data = column.filters[0].data;
      	}
        let start = this.$util.formatDate.format(column.filters[0].data , 'yyyy-MM-dd');
        let end = this.$util.formatDate.format(column.filters[1].data , 'yyyy-MM-dd');
        if(typeof(row[column.property])==="object") {
        	let value = row[column.property].value;
        	return start <= value && value<=end
        }else {
        	return start <= row[column.property] && row[column.property]<=end
        }
      },
      // 文本搜索
      filtersTextMethod({option, row,column,type}){
      	if(row.isBeginning===1){return true};
         if(option.data===""){
            return false;
         }
         if(typeof(row[column.property])==="object") {
         		if(row[column.property].value !==""){
         			if(option.isAccurate) {  // 精确筛选
         				return row[column.property].value.toLowerCase() === option.data.toLowerCase();
         			}else {  // 模糊筛选
         				return (row[column.property].value.toLowerCase()).indexOf(option.data.toLowerCase())>=0;
         			}

           }else {
            return false;
           }
         }else {
         		if(row[column.property] !==""){
         			if(option.isAccurate) {  // 精确筛选
         				return row[column.property].toLowerCase() === option.data.toLowerCase();
         			}else {  // 模糊筛选
         				 return (row[column.property].toLowerCase()).indexOf(option.data.toLowerCase())>=0;
         			}
           }else {
            return false;
           }
         }

      },
      // 自定义合计方法
      footerMethod ({ columns, data }) {
        let sum="",arr=['debitMoney', 'creditorMoney'];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return '全部合计'
            }
            if (columnIndex === 2) {
              return '共'+(data.length===0?0:data.length-1)+"条数据"
            }
           if(column._own!==undefined&&column._own.isTotal===1) {
              arr.push(column.property);
           }
            if (arr.includes(column.property)) {
                const values = data.map(item => {
                  if(typeof(item[column.property])==="object") {
                    return Number(item[column.property].value)
                  }else {
                      return Number(item[column.property])
                  }
                });
                if (!values.every(value => {isNaN(value)})) {
                    sum = values.reduce((prev, curr) => {
                      const value = Number(curr);
                      if(!isNaN(value)) {
                          if(!(parseFloat(prev)+parseFloat(curr))) {
                                return 0;
                              }else {
                                  return (parseFloat(prev)+parseFloat(curr)).toFixed(2);
                              }
                      }else {
                        return parseFloat(prev).toFixed(2);
                      }
                   })
                }else {
                  sum = "";
                }
                return currencys(sum);
            }

          })
        ]
      },
      // 用户更新日记账版本后第一次进来需确认字段归属
      userChoice() {
        this.$http.post('custom/getIsFillRule',{}).then(res=>{
           if(res && res.data.code == 1) {
            this.$nextTick(()=>{
              this.$refs.choiceTypeRef.dialogVisible = res.data.data;
            })
           }
        })
      },

      // 跳转新增日记账
      addCashierdiary() {
        this.$router.push({ path:"./add-cashierdiary" })
      },
      // 账户改动
      accountChange(val) {
        this.getTableData();
      },
      getDataChange(val) {
        if(!val) {
          this.formData.startYearPeriods = "";
          this.formData.endYearPeriods = "";
        }else {
          this.formData.startYearPeriods = val[0];
          this.formData.endYearPeriods = val[1];
        }

        this.getTableData();
      },
      // 获取打印导出导入按钮权限
      getButtonAuthorize() {
        let params={
          permissions:'ac:diary:print,ac:diary:import,ac:diary:export'
        }
         this.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
            if(res && res.data.code == 1) {
              this.RightBtnList = res.data.data;
            }
         })

         // 获取删除按钮
         let params_d={
          permissions:'ac:diary:move,ac:diary:deleted,ac:diary:recovery'
        }
         this.$http.post('sys/menu/findPermissionMenu',params_d).then(res=>{
            if(res && res.data.code == 1) {
              this.centerBtnList = res.data.data;
            }
         })
      },
    }
  }
</script>
<style lang="less" scoped>
  @import "../../assets/css/cashierdiary/queryCashierdiary.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/cashierdiary.vue